// extracted by mini-css-extract-plugin
module.exports = {"Block":"block_Block__1iq0x","Player":"block_Player__VjaUR","Start":"block_Start__qx7vz","Finish":"block_Finish__3DI1O","Disabled":"block_Disabled__Ktva1"};